/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Group} from '@ion/core/src/types/entities';
import {DropDownInfiniteScrollProps} from '@ion/dls/src/components/menus/Dropdown';
import {AdminGroupEditor} from '@ion/dls/src/editors/AdminGroupEditor';
import {useAuthenticatedUser} from '../users/useAuthenticatedUser';
import {addGroup, addGroupConfirm} from './state';

// Defines the prop definitiions for the AddGroupEditor
export interface AddGroupEditorProps extends DropDownInfiniteScrollProps {
  isCtcAdmin: boolean;
  includeDeviceGridCheckboxes?: boolean;
  includeAssetGridCheckboxes?: boolean;
  hasInheritableGroups?: boolean;
};

/**
 * It will show AddGroupEditor dialog when use click on Add new button
 */
export const AddGroupEditor = ({
  isCtcAdmin = false,
  includeDeviceGridCheckboxes = false,
  hasInheritableGroups = false,
  includeAssetGridCheckboxes = false,
  isInfiniteScroll = false
}: AddGroupEditorProps) => {
  const dispatch      = useDispatch();
  const {account}     = useAuthenticatedUser();
  const {globalGroup} = useSelector(({globalGroup}) => globalGroup);
  const {loading}     = useSelector(({groups: {add}}) => add);

  const onGroupAdd = function() {
    dispatch(addGroup(false));
  };

  return (
    <AdminGroupEditor open
      isAdd
      isCtcAdmin={isCtcAdmin}
      account={globalGroup || account}
      loading={loading}
      hasInheritableGroups={hasInheritableGroups}
      includeDeviceGridCheckboxes={includeDeviceGridCheckboxes}
      includeAssetGridCheckboxes={includeAssetGridCheckboxes}
      onSave={function(group: Group) {
        dispatch(addGroupConfirm(group));
      }}
      onCancel={onGroupAdd}
      onCloseDialog={onGroupAdd}
      isInfiniteScroll={isInfiniteScroll} />
  );
};

export default AddGroupEditor;
